import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OnlineMeeting } from '@microsoft/microsoft-graph-types';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TeamsMeetingDTO } from '../models/teams-meeting.model';
import { MeetingCrudService } from '../models/meeting-crud-service.model';
import { MeetingLinkCourseSelfStudyDTO } from '../models/meeting-link-course-self-study-dto.model';

@Injectable({
  providedIn: 'root',
})
export class TeamsCourseMeetingService implements MeetingCrudService {
  private apiUrl = environment.apiUrl + '/teamsmeeting/course-self-study';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Erstellt ein neues Teams Meeting.
   * @param meeting Die Daten des zu erstellenden Meetings.
   * @param name Der Name des Kurses, für den das Meeting erstellt werden soll.
   * @returns Observable mit dem erstellten Teams Meeting als einelementige Liste — der Kurs-Endpunkt
   * legt genau ein Meeting an, MeetingCrudService.create ist aber für beide Pfade eine Liste.
   */
  create(meeting: OnlineMeeting, name: string): Observable<TeamsMeetingDTO[]> {
    return this.httpClient
      .post<TeamsMeetingDTO>(this.apiUrl, meeting, {
        params: new HttpParams().set('name', name),
      })
      .pipe(map((createdMeeting) => [createdMeeting]));
  }

  /**
   * Aktualisiert ein bestehendes Teams Meeting.
   * @param meetingId Die ID des Meetings.
   * @param meeting Die aktualisierten Daten des Meetings.
   * @returns TeamsMeetingDTO Observable mit dem aktualisierten Teams Meeting.
   */
  update(
    meetingId: string,
    meeting: OnlineMeeting,
  ): Observable<TeamsMeetingDTO> {
    return this.httpClient.put<TeamsMeetingDTO>(
      `${this.apiUrl}/${encodeURIComponent(meetingId)}`,
      meeting,
    );
  }

  /**
   * Löscht ein Teams Meeting anhand der Meeting-ID.
   * @param meetingId Die ID des Meetings.
   * @returns Observable<void>
   */
  delete(meetingId: string): Observable<void> {
    return this.httpClient.delete<void>(
      `${this.apiUrl}/${encodeURIComponent(meetingId)}`,
    );
  }

  /**
   * Erstellt alle Teams Meetings für Selbststudium-Kurse.
   * Erstellt außerdem für jeden Kurs einen Eintrag in die TeamsMeetingConfig Tabelle,
   * damit die Kurse in der Konfigurationstabelle angezeigt werden.
   */
  createAll(): Observable<any> {
    return this.httpClient.post(`${this.apiUrl}/all`, {});
  }

  /**
   * Holt alle Teams Meeting Links für Selbststudium-Kurse.
   */
  getAll(): Observable<MeetingLinkCourseSelfStudyDTO[]> {
    return this.httpClient.get<MeetingLinkCourseSelfStudyDTO[]>(
      `${this.apiUrl}/all`,
    );
  }
}
